import { render } from "./CustomFieldInput.vue?vue&type=template&id=85e6227c&scoped=true"
import script from "./CustomFieldInput.vue?vue&type=script&lang=js"
export * from "./CustomFieldInput.vue?vue&type=script&lang=js"

import "./CustomFieldInput.vue?vue&type=style&index=0&id=85e6227c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85e6227c"]])

export default __exports__